import { Permission, type User } from "@/model/RootStore"

const adminPermissions = [
	Permission.AuthorizationRead,
	Permission.AuthorizationWrite,
	Permission.EmailCreate,
	Permission.ServiceTokenWrite,
	Permission.DashboardRead,
]

export function hasAdminAccess(user: User | undefined): boolean {
	return adminPermissions.some(permission => user?.has(permission))
}
